import {
  AUTH_ADMIN_INFO_RESPONSE,
  AUTH_LOGIN_REQUEST_BODY,
  AUTH_LOGIN_RESPONSE,
  AUTH_RESPONSE,
} from '@assets/types/authTypes';
import { useFetch } from '@hooks/fetch/useFetch';

export const getAdminInfo = (): {
  data: AUTH_ADMIN_INFO_RESPONSE | null;
  loading: boolean;
  error: Record<string, unknown> | null;
} => {
  const token = localStorage.getItem('cdp_t');
  if (!token)
    return { data: null, loading: false, error: { message: 'emptyToken' } };

  const headers = { 'gosky-api-key': token };
  return useFetch<AUTH_ADMIN_INFO_RESPONSE, Record<string, unknown>>(
    `${process.env.REACT_APP_RESTFUL_END_POINT}/console/auth/admin_info`,
    {
      headers,
      method: 'GET',
    },
  );
};

export const login = (
  body: AUTH_LOGIN_REQUEST_BODY,
): Promise<AUTH_LOGIN_RESPONSE | AUTH_RESPONSE> => {
  return fetch(
    `${process.env.REACT_APP_RESTFUL_END_POINT}/console/auth/login`,
    {
      headers: { 'content-type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ admin: body }),
    },
  ).then((res) => {
    return res.json();
  });
};

export const logout = (): Promise<AUTH_RESPONSE> => {
  const token = localStorage.getItem('cdp_t');
  if (!token)
    return Promise.resolve({
      status: 'EMPTY_TOKEN',
      message: 'emptyToken',
    });

  return fetch(
    `${process.env.REACT_APP_RESTFUL_END_POINT}/console/auth/logout`,
    {
      method: 'POST',
      headers: { 'gosky-api-key': token },
    },
  ).then((res) => {
    return res.json();
  });
};
